import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LayoutState, initialLayoutState } from './layoutState';

const layoutSlice = createSlice({
    name: 'layout',
    initialState: initialLayoutState,
    reducers: {
        setIsCollapsed: (state: LayoutState, action: PayloadAction<boolean>) => {
            state.isCollapsed = action.payload;
        },
        setIsSmallScreen: (state: LayoutState, action: PayloadAction<boolean>) => {
            state.isSmallScreen = action.payload;
        },
        setIsOverlay: (state: LayoutState, action: PayloadAction<boolean>) => {
            state.isOverlay = action.payload;
        },
    },
});

export const { setIsCollapsed, setIsSmallScreen, setIsOverlay } = layoutSlice.actions;

export default layoutSlice.reducer;
